
/* V71: plus/minus cart steppers, zero automatically removes item */
(() => {
  const modal = document.querySelector('[data-fg-cart-added-modal]');
  if (!modal) return;

  if (modal.parentElement !== document.body) {
    document.body.appendChild(modal);
  }

  const itemsWrap = modal.querySelector('[data-fg-cart-added-items]');
  const subtotalEl = modal.querySelector('[data-fg-cart-added-subtotal]');
  let changing = false;

  const formatMoney = (cents) => {
    const amount = Number(cents || 0) / 100;
    const currency =
      (window.Shopify && Shopify.currency && Shopify.currency.active) || 'AUD';

    try {
      return new Intl.NumberFormat(
        document.documentElement.lang || 'en-AU',
        { style: 'currency', currency }
      ).format(amount);
    } catch (_) {
      return `$${amount.toFixed(2)}`;
    }
  };

  const updateCartCount = (cart) => {
    document.querySelectorAll('.fg-cart-count').forEach((count) => {
      count.textContent = `(${cart.item_count})`;
    });
  };

  const renderMiniCartFromCart = (cart) => {
    updateCartCount(cart);

    const miniSubtotal = document.querySelector('.fg-cart-popover__summary strong');
    if (miniSubtotal) miniSubtotal.textContent = formatMoney(cart.total_price);

    document.querySelectorAll('[data-fg-mini-cart-item]').forEach((row) => {
      const line = Number(row.dataset.line || 0);
      const item = cart.items[line - 1];

      if (!item) {
        row.remove();
        return;
      }

      const value = row.querySelector('[data-fg-mini-cart-qty-value]');
      const price = row.querySelector('[data-fg-mini-cart-line-price]');
      if (value) value.textContent = item.quantity;
      if (price) price.textContent = formatMoney(item.final_line_price);
    });

    syncMinimumQuantityState();

    // If the cart becomes empty, reload just once so Liquid swaps the mini-cart empty state.
    if (cart.item_count === 0) {
      window.location.reload();
    }
  };

  const renderCartModal = (cart) => {
    if (!itemsWrap) return;

    if (!cart || !Array.isArray(cart.items) || cart.items.length === 0) {
      itemsWrap.innerHTML = '<div class="fg-cart-added-modal__empty">Your cart is empty.</div>';
      if (subtotalEl) subtotalEl.textContent = formatMoney(0);
      updateCartCount(cart || { item_count: 0 });
      return;
    }

    itemsWrap.innerHTML = cart.items.map((item, index) => {
      const line = index + 1;
      const image = item.image
        ? `<img src="${item.image}" alt="" loading="lazy">`
        : '';

      const variant =
        item.variant_title && item.variant_title !== 'Default Title'
          ? `<div class="fg-cart-added-modal__variant">${item.variant_title}</div>`
          : '';

      return `
        <div class="fg-cart-added-modal__item" data-fg-modal-cart-item data-line="${line}">
          <div class="fg-cart-added-modal__image" aria-hidden="true">
            ${image}
          </div>
          <div class="fg-cart-added-modal__info">
            <div class="fg-cart-added-modal__title">${item.product_title || item.title || ''}</div>
            ${variant}
            <div class="fg-cart-added-modal__itembottom">
              <div class="fg-cart-added-modal__stepper" data-fg-cart-stepper data-line="${line}" aria-label="Quantity for ${item.product_title || item.title || 'cart item'}">
                <button type="button" class="fg-cart-stepper__button" data-fg-cart-qty-minus data-line="${line}" aria-label="Decrease quantity" ${item.quantity <= 1 ? 'disabled aria-disabled="true"' : ''}>−</button>
                <span class="fg-cart-stepper__value" data-fg-modal-cart-qty-value>${item.quantity}</span>
                <button type="button" class="fg-cart-stepper__button" data-fg-cart-qty-plus data-line="${line}" aria-label="Increase quantity">+</button>
              </div>
              <strong class="fg-cart-added-modal__lineprice">${formatMoney(item.final_line_price)}</strong>
            </div>
          </div>
        </div>
      `;
    }).join('');

    if (subtotalEl) subtotalEl.textContent = formatMoney(cart.total_price);
    renderMiniCartFromCart(cart);
  };

  const fetchCart = async () => {
    const response = await fetch('/cart.js', {
      headers: { 'Accept': 'application/json' }
    });
    if (!response.ok) throw new Error('Unable to load cart');
    return response.json();
  };

  const changeLineQuantity = async (line, quantity) => {
    const response = await fetch('/cart/change.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({
        line,
        quantity: Math.max(0, Number(quantity || 0))
      })
    });

    if (!response.ok) throw new Error('Unable to update cart');
    return response.json();
  };

  const getCurrentQuantity = (line) => {
    const modalRow = modal.querySelector(`[data-fg-modal-cart-item][data-line="${line}"]`);
    const modalValue = modalRow?.querySelector('[data-fg-modal-cart-qty-value]');
    if (modalValue) return Number(modalValue.textContent || 0);

    const miniRow = document.querySelector(`[data-fg-mini-cart-item][data-line="${line}"]`);
    const miniValue = miniRow?.querySelector('[data-fg-mini-cart-qty-value]');
    return Number(miniValue?.textContent || 0);
  };

  const setSteppersDisabled = (disabled) => {
    document.querySelectorAll('[data-fg-cart-qty-minus], [data-fg-cart-qty-plus]').forEach((button) => {
      button.disabled = disabled;
    });
  };

  const syncMinimumQuantityState = () => {
    document.querySelectorAll('[data-fg-cart-stepper]').forEach((stepper) => {
      const value = stepper.querySelector('[data-fg-mini-cart-qty-value], [data-fg-modal-cart-qty-value]');
      const minus = stepper.querySelector('[data-fg-cart-qty-minus]');
      if (!minus || !value) return;

      const atMinimum = Number(value.textContent || 0) <= 1;
      minus.disabled = atMinimum;
      minus.setAttribute('aria-disabled', String(atMinimum));
    });
  };

  const updateQuantity = async (line, nextQuantity) => {
    if (changing || !line) return;
    changing = true;
    setSteppersDisabled(true);

    try {
      const cart = await changeLineQuantity(line, nextQuantity);

      // Re-rendering from Shopify's response reindexes line numbers after an item is removed.
      renderMiniCartFromCart(cart);
      if (!modal.hidden) renderCartModal(cart);

      if (cart.item_count === 0 && !modal.hidden) {
        if (subtotalEl) subtotalEl.textContent = formatMoney(0);
      }
    } catch (_) {
      const cart = await fetchCart().catch(() => null);
      if (cart) {
        renderMiniCartFromCart(cart);
        if (!modal.hidden) renderCartModal(cart);
      }
    } finally {
      changing = false;
      setSteppersDisabled(false);
      syncMinimumQuantityState();
    }
  };

  const refreshCart = async () => {
    if (itemsWrap && !modal.hidden) {
      itemsWrap.innerHTML = '<div class="fg-cart-added-modal__loading">Updating your cart…</div>';
    }

    try {
      const cart = await fetchCart();
      if (!modal.hidden) renderCartModal(cart);
      else renderMiniCartFromCart(cart);
      return cart;
    } catch (_) {
      if (itemsWrap && !modal.hidden) {
        itemsWrap.innerHTML = '<div class="fg-cart-added-modal__empty">Your cart could not be refreshed.</div>';
      }
      return null;
    }
  };

  const open = async () => {
    modal.hidden = false;
    document.documentElement.classList.add('fg-cart-added-modal-open');
    document.body.classList.add('fg-cart-added-modal-open');
    await refreshCart();
  };

  const close = () => {
    modal.hidden = true;
    document.documentElement.classList.remove('fg-cart-added-modal-open');
    document.body.classList.remove('fg-cart-added-modal-open');
  };

  window.FGOpenCartAddedModal = open;
  window.FGCloseCartAddedModal = close;
  window.FGRefreshCartViews = refreshCart;

  document.addEventListener('click', async (event) => {
    const minus = event.target.closest('[data-fg-cart-qty-minus]');
    const plus = event.target.closest('[data-fg-cart-qty-plus]');

    if (minus || plus) {
      event.preventDefault();
      event.stopPropagation();

      const button = minus || plus;
      const stepper = button.closest('[data-fg-cart-stepper]');
      const line = Number(button.dataset.line || stepper?.dataset.line || 0);
      const visibleValue = stepper?.querySelector('[data-fg-mini-cart-qty-value], [data-fg-modal-cart-qty-value]');
      const current = Math.max(1, Number(visibleValue?.textContent || 1));
      if (minus && current <= 1) {
        syncMinimumQuantityState();
        return;
      }
      const next = plus ? current + 1 : Math.max(1, current - 1);

      await updateQuantity(line, next);
      return;
    }

    const closeTrigger = event.target.closest('[data-fg-cart-added-close]');
    if (closeTrigger) {
      event.preventDefault();
      close();
    }
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && !modal.hidden) close();
  });
})();


document.documentElement.classList.remove('no-js');
document.addEventListener('click', function(e){
  const toggle=e.target.closest('[data-fg-mobile-toggle]');
  if(toggle){
    const nav=document.getElementById(toggle.getAttribute('aria-controls'));
    if(nav){
      nav.hidden = !nav.hidden;
      toggle.setAttribute('aria-expanded', String(!nav.hidden));
      toggle.setAttribute('aria-label', nav.hidden ? 'Open menu' : 'Close menu');
    }
  }
});
document.addEventListener('keydown', function(e){
  if(e.key !== 'Escape') return;
  const nav=document.querySelector('[data-fg-mobile-nav]:not([hidden])');
  if(!nav) return;
  const toggle=nav.closest('[data-fg-header]').querySelector('[data-fg-mobile-toggle]');
  nav.hidden=true;
  if(toggle){
    toggle.setAttribute('aria-expanded','false');
    toggle.setAttribute('aria-label','Open menu');
    toggle.focus();
  }
});


(() => { const init=(root=document)=>{
const anchor=root.querySelector('[data-fg-search-panel]');if(!anchor||anchor.dataset.fgSearchReady)return;anchor.dataset.fgSearchReady='true';

  const toggle = root.querySelector('[data-fg-search-toggle]');
  const panel = root.querySelector('[data-fg-search-panel]');
  const close = root.querySelector('[data-fg-search-close]');
  const input = root.querySelector('[data-fg-search-input]');
  const results = root.querySelector('[data-fg-search-results]');

  if(!toggle || !panel || !input || !results) return;

  let debounceTimer;
  let controller;

  const openSearch = () => {
    panel.hidden = false;
    toggle.setAttribute('aria-expanded','true');
    document.documentElement.classList.add('fg-search-open');
    window.setTimeout(() => input.focus(), 20);
  };

  const closeSearch = () => {
    panel.hidden = true;
    toggle.setAttribute('aria-expanded','false');
    document.documentElement.classList.remove('fg-search-open');
  };

  toggle.addEventListener('click', () => {
    if(panel.hidden) openSearch();
    else closeSearch();
  });

  if(close) close.addEventListener('click', closeSearch);

  document.addEventListener('keydown', (event) => {
    if(event.key === 'Escape' && !panel.hidden) closeSearch();
  });

  document.addEventListener('click', (event) => {
    if(panel.hidden) return;
    if(panel.contains(event.target) || toggle.contains(event.target)) return;
    closeSearch();
  });

  const renderIntro = () => {
    results.innerHTML = '<div class="fg-predictive__intro"><span class="fg-predictive__intro-title">What are you looking for?</span><span>Start typing to see products instantly.</span></div>';
  };

  const fetchResults = async (term) => {
    if(controller) controller.abort();
    controller = new AbortController();

    results.innerHTML = '<div class="fg-predictive__loading">Searching…</div>';

    const base = panel.dataset.predictiveUrl || '/search/suggest';
    const url = `${base}?q=${encodeURIComponent(term)}&resources[type]=product&resources[limit]=6&section_id=predictive-search`;

    try{
      const response = await fetch(url, { signal: controller.signal });
      if(!response.ok) throw new Error('Search request failed');
      const text = await response.text();
      const doc = new DOMParser().parseFromString(text, 'text/html');
      const section = doc.querySelector('#shopify-section-predictive-search');
      results.innerHTML = section ? section.innerHTML : text;
    }catch(error){
      if(error.name === 'AbortError') return;
      results.innerHTML = '<div class="fg-predictive__empty"><strong>Search is temporarily unavailable.</strong><span>Press Enter to use the full search page.</span></div>';
    }
  };

  input.addEventListener('input', () => {
    const term = input.value.trim();
    window.clearTimeout(debounceTimer);

    if(term.length < 2){
      if(term.length === 0) renderIntro();
      else results.innerHTML = '<div class="fg-predictive__intro"><span>Type at least 2 characters.</span></div>';
      return;
    }

    debounceTimer = window.setTimeout(() => fetchResults(term), 220);
  });

};init();document.addEventListener('shopify:section:load',event=>init(event.target));})();


/* V19 product-card Add to Cart */
document.addEventListener('click', async (event) => {
  const button = event.target.closest('[data-fg-card-add]');
  if (!button) return;

  event.preventDefault();
  if (button.disabled) return;

  const variantId = button.dataset.variantId;
  if (!variantId) return;

  const originalText = button.textContent;
  button.disabled = true;
  button.textContent = 'Adding…';

  try {
    const response = await fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({
        items: [{ id: Number(variantId), quantity: 1 }]
      })
    });

    if (!response.ok) throw new Error('Unable to add product');

    button.textContent = 'Added ✓';
    window.FGOpenCartAddedModal?.();

    const cartResponse = await fetch('/cart.js', {
      headers: { 'Accept': 'application/json' }
    });
    if (cartResponse.ok) {
      const cart = await cartResponse.json();
      document.querySelectorAll('.fg-cart-count').forEach((count) => {
        count.textContent = `(${cart.item_count})`;
      });

      const cartIcon = document.querySelector('.fg-cart-icon');
      if (cartIcon && !cartIcon.querySelector('.fg-cart-count')) {
        const count = document.createElement('span');
        count.className = 'fg-cart-count';
        count.textContent = `(${cart.item_count})`;
        cartIcon.appendChild(count);
      }
    }

    window.setTimeout(() => {
      button.disabled = false;
      button.textContent = originalText;
    }, 1400);
  } catch (error) {
    button.disabled = false;
    button.textContent = 'Try again';
    window.setTimeout(() => {
      button.textContent = originalText;
    }, 1800);
  }
});


/* V24 main product-page AJAX Add to Cart */
document.addEventListener('submit', async (event) => {
  const form = event.target.closest('.fg-product-form');
  if (!form) return;

  const button = form.querySelector('[data-fg-main-product-add]');
  if (!button) return;

  event.preventDefault();
  if (button.disabled) return;

  const variantInput = form.querySelector('[name="id"]');
  const quantityInput = form.querySelector('[name="quantity"]');
  if (!variantInput || !variantInput.value) return;

  const originalText = button.textContent.trim();
  button.disabled = true;
  button.textContent = 'Adding…';

  try {
    const response = await fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({
        items: [{
          id: Number(variantInput.value),
          quantity: Math.max(1, Number(quantityInput?.value || 1))
        }]
      })
    });

    if (!response.ok) throw new Error('Unable to add product');

    button.textContent = 'Added ✓';
    window.FGOpenCartAddedModal?.();

    const cartResponse = await fetch('/cart.js', {
      headers: { 'Accept': 'application/json' }
    });

    if (cartResponse.ok) {
      const cart = await cartResponse.json();

      let cartCount = document.querySelector('.fg-cart-count');
      if (!cartCount) {
        const cartIcon = document.querySelector('.fg-cart-icon');
        if (cartIcon) {
          cartCount = document.createElement('span');
          cartCount.className = 'fg-cart-count';
          cartIcon.appendChild(cartCount);
        }
      }

      if (cartCount) cartCount.textContent = `(${cart.item_count})`;
    }

    window.setTimeout(() => {
      button.disabled = false;
      button.textContent = originalText;
    }, 1400);
  } catch (error) {
    button.disabled = false;
    button.textContent = 'Try again';
    window.setTimeout(() => {
      button.textContent = originalText;
    }, 1800);
  }
});


/* V26 mini-cart Remove */
document.addEventListener('click', async (event) => {
  const button = event.target.closest('[data-fg-cart-remove]');
  if (!button) return;

  event.preventDefault();
  event.stopPropagation();

  if (button.disabled) return;

  const line = Number(button.dataset.line);
  if (!line) return;

  const originalText = button.textContent.trim();
  button.disabled = true;
  button.textContent = 'Removing…';

  try {
    const response = await fetch('/cart/change.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({ line, quantity: 0 })
    });

    if (!response.ok) throw new Error('Unable to remove item');

    const cart = await response.json();

    // Update the visible cart count.
    document.querySelectorAll('.fg-cart-count').forEach((count) => {
      count.textContent = `(${cart.item_count})`;
    });

    // Update subtotal.
    const subtotal = document.querySelector('.fg-cart-popover__summary strong');
    if (subtotal) {
      subtotal.textContent = new Intl.NumberFormat(
        document.documentElement.lang || 'en-AU',
        { style: 'currency', currency: Shopify.currency.active || 'AUD' }
      ).format(cart.total_price / 100);
    }

    // Remove this row immediately.
    const row = button.closest('[data-fg-mini-cart-item]');
    if (row) row.remove();

    // If cart is now empty, swap the preview to its empty state.
    if (cart.item_count === 0) {
      const popover = button.closest('.fg-cart-popover');
      if (popover) {
        popover.innerHTML = `
          <div class="fg-cart-popover__empty">
            <strong>Your cart is empty</strong>
            <span>Add something cosy to get started.</span>
            <a class="fg-btn" href="/collections/all">Shop all</a>
          </div>
        `;
      }
      return;
    }

    // Keep remaining line numbers valid after removal.
    document.querySelectorAll('[data-fg-mini-cart-item]').forEach((item, index) => {
      const newLine = index + 1;
      item.dataset.line = newLine;
      const remove = item.querySelector('[data-fg-cart-remove]');
      if (remove) remove.dataset.line = newLine;
    });

  } catch (error) {
    button.disabled = false;
    button.textContent = 'Try again';
    window.setTimeout(() => {
      button.textContent = originalText;
    }, 1600);
  }
});


/* V31 explicit search clear control */
(() => { const init=(root=document)=>{
const anchor=root.querySelector('[data-fg-search-input]');if(!anchor||anchor.dataset.fgClearReady)return;anchor.dataset.fgClearReady='true';

  const input = root.querySelector('[data-fg-search-input]');
  const clear = root.querySelector('[data-fg-search-clear]');
  const results = root.querySelector('[data-fg-search-results]');

  if (!input || !clear) return;

  const syncClear = () => {
    clear.hidden = input.value.length === 0;
  };

  input.addEventListener('input', syncClear);

  clear.addEventListener('click', () => {
    input.value = '';
    clear.hidden = true;
    input.focus();

    if (results) {
      results.innerHTML = '<div class="fg-predictive__intro"><span class="fg-predictive__intro-title">What are you looking for?</span><span>Start typing to see products instantly.</span></div>';
    }

    input.dispatchEvent(new Event('input', { bubbles: true }));
  });

  syncClear();

};init();document.addEventListener('shopify:section:load',event=>init(event.target));})();


/* V32: split product specs/origin out of legacy product descriptions */
(() => { const init=(root=document)=>{
const anchor=root.querySelector('[data-fg-product-description]');if(!anchor||anchor.dataset.fgDescriptionReady)return;anchor.dataset.fgDescriptionReady='true';

  const description = root.querySelector('[data-fg-product-description]');
  const specsDropdown = root.querySelector('[data-fg-specs-dropdown]');
  const specsContent = root.querySelector('[data-fg-specs-content]');
  const originDropdown = root.querySelector('[data-fg-origin-dropdown]');
  const originContent = root.querySelector('[data-fg-origin-content]');

  if (!description || !specsDropdown || !specsContent || !originDropdown || !originContent) return;

  const hasMeaningfulContent = (el) =>
    el.textContent.replace(/\s+/g, ' ').trim().length > 0;

  // If metafields already supplied content, keep them and only remove matching legacy lines.
  const specLabels = {
    size: /^(size|dimensions?)\s*:\s*(.+)$/i,
    weight: /^weight\s*:\s*(.+)$/i,
    material: /^materials?\s*:\s*(.+)$/i
  };
  const originPattern = /^country\s+of\s+origin\s*:\s*(.+)$/i;

  const existingSpecsText = specsContent.textContent.toLowerCase();
  const hasSize = existingSpecsText.includes('size:');
  const hasWeight = existingSpecsText.includes('weight:');
  const hasMaterial = existingSpecsText.includes('material:');
  const hasOrigin = hasMeaningfulContent(originContent);

  const candidates = Array.from(description.querySelectorAll('p, li'));

  candidates.forEach((node) => {
    const value = node.textContent.replace(/\s+/g, ' ').trim();
    let match;

    if ((match = value.match(specLabels.size))) {
      if (!hasSize) {
        const p = document.createElement('p');
        p.innerHTML = `<strong>Size:</strong> ${match[2]}`;
        specsContent.appendChild(p);
      }
      node.remove();
      return;
    }

    if ((match = value.match(specLabels.weight))) {
      if (!hasWeight) {
        const p = document.createElement('p');
        p.innerHTML = `<strong>Weight:</strong> ${match[1]}`;
        specsContent.appendChild(p);
      }
      node.remove();
      return;
    }

    if ((match = value.match(specLabels.material))) {
      if (!hasMaterial) {
        const p = document.createElement('p');
        p.innerHTML = '<strong>Material:</strong> ';
        p.appendChild(document.createTextNode(match[1]));
        specsContent.appendChild(p);
      }
      node.remove();
      return;
    }

    if ((match = value.match(originPattern))) {
      if (!hasOrigin) {
        const p = document.createElement('p');
        p.textContent = match[1];
        originContent.appendChild(p);
      }
      node.remove();
    }
  });

  // Hide empty dropdowns only if neither metafields nor legacy description supplied data.
  if (!window.Shopify?.designMode && !hasMeaningfulContent(specsContent)) specsDropdown.hidden = true;
  if (!window.Shopify?.designMode && !hasMeaningfulContent(originContent)) originDropdown.hidden = true;

};init();document.addEventListener('shopify:section:load',event=>init(event.target));})();


/* V47: make the Shopify section wrapper containing FG Header sticky */
(() => {
  const applyStickyHeader = () => {
    const header = document.querySelector('.fg-header');
    if (!header) return;

    const wrapper = header.closest('.shopify-section');
    if (wrapper) {
      wrapper.classList.toggle('fg-header-section-sticky', header.dataset.sticky !== 'false');
    }
  };

  document.addEventListener('DOMContentLoaded', applyStickyHeader);
  document.addEventListener('shopify:section:load', applyStickyHeader);
  applyStickyHeader();
})();


/* V48 FG Hero slideshow */
(() => {
  const initHeroSlider = (slider) => {
    if (!slider || slider.dataset.fgHeroReady === 'true') return;

    const slides = Array.from(slider.querySelectorAll('[data-fg-hero-slide]'));
    const dots = Array.from(slider.querySelectorAll('[data-fg-hero-dot]'));
    const prev = slider.querySelector('[data-fg-hero-prev]');
    const next = slider.querySelector('[data-fg-hero-next]');

    if (slides.length <= 1) {
      slider.dataset.fgHeroReady = 'true';
      return;
    }

    let current = Math.max(0, slides.findIndex((slide) => slide.classList.contains('is-active')));
    let timer = null;

    // Keep the arrows/dots vertically aligned with the actual mobile image.
    // Each slide can have a different image and aspect ratio.
    const syncMobileImageHeight = () => {
      const media = slides[current]?.querySelector('.fg-hero__media');
      const imageHeight = media?.getBoundingClientRect().height || 0;
      if (imageHeight > 0) {
        slider.style.setProperty('--fg-active-image-height', `${imageHeight}px`);
      }
    };

    slides.forEach((slide) => {
      slide.querySelector('.fg-hero__media img')?.addEventListener('load', syncMobileImageHeight);
    });
    window.addEventListener('resize', syncMobileImageHeight);

    const autoplay = slider.dataset.autoplay === 'true';
    const interval = Math.max(3000, Number(slider.dataset.interval || 5000));

    const show = (index, restart = true) => {
      current = (index + slides.length) % slides.length;

      slides.forEach((slide, i) => {
        const active = i === current;
        slide.classList.toggle('is-active', active);
        slide.setAttribute('aria-hidden', active ? 'false' : 'true');
      });

      dots.forEach((dot, i) => {
        const active = i === current;
        dot.classList.toggle('is-active', active);
        dot.setAttribute('aria-current', active ? 'true' : 'false');
      });

      syncMobileImageHeight();
      if (restart) start();
    };

    const stop = () => {
      if (timer) {
        window.clearInterval(timer);
        timer = null;
      }
    };

    const start = () => {
      stop();
      if (!autoplay || document.documentElement.classList.contains('shopify-design-mode')) return;
      timer = window.setInterval(() => show(current + 1, false), interval);
    };

    prev?.addEventListener('click', () => show(current - 1));
    next?.addEventListener('click', () => show(current + 1));

    dots.forEach((dot, index) => {
      dot.addEventListener('click', () => show(index));
    });

    slider.addEventListener('mouseenter', stop);
    slider.addEventListener('mouseleave', start);
    slider.addEventListener('focusin', stop);
    slider.addEventListener('focusout', start);

    document.addEventListener('visibilitychange', () => {
      if (document.hidden) stop();
      else start();
    });

    slider._fgHeroShow = show;
    slider._fgHeroStop = stop;
    slider._fgHeroStart = start;
    slider.dataset.fgHeroReady = 'true';

    show(current, false);
    start();
  };

  const initAll = (root = document) => {
    root.querySelectorAll('[data-fg-hero-slider]').forEach(initHeroSlider);
  };

  document.addEventListener('DOMContentLoaded', () => initAll());
  document.addEventListener('shopify:section:load', (event) => initAll(event.target));

  document.addEventListener('shopify:block:select', (event) => {
    const block = event.target;
    if (!block?.classList?.contains('fg-hero-slide')) return;

    const slider = block.closest('[data-fg-hero-slider]');
    if (!slider) return;

    const slides = Array.from(slider.querySelectorAll('[data-fg-hero-slide]'));
    const index = slides.indexOf(block);

    if (index >= 0 && slider._fgHeroShow) {
      slider._fgHeroStop?.();
      slider._fgHeroShow(index, false);
    }
  });

  document.addEventListener('shopify:block:deselect', (event) => {
    const slider = event.target?.closest?.('[data-fg-hero-slider]');
    slider?._fgHeroStart?.();
  });

  initAll();
})();


/* V49: auto-update cart quantity inputs */
document.addEventListener('change', (event) => {
  const input = event.target.closest('.fg-cart-qty input[name="updates[]"]');
  if (!input) return;

  const form = input.closest('form.fg-cart-items');
  if (!form) return;

  // Submit the cart form automatically after a quantity change.
  if (typeof form.requestSubmit === 'function') {
    form.requestSubmit();
  } else {
    form.submit();
  }
});


/* V51: delayed-close mini-cart so it doesn't vanish while moving the mouse */
(() => {
  const initMiniCartHover = (root = document) => {
    root.querySelectorAll('[data-fg-cart-hover]').forEach((wrap) => {
      if (wrap.dataset.fgHoverReady === 'true') return;

      let closeTimer = null;

      const open = () => {
        if (closeTimer) {
          window.clearTimeout(closeTimer);
          closeTimer = null;
        }
        wrap.classList.add('is-open');
      };

      const scheduleClose = () => {
        if (closeTimer) window.clearTimeout(closeTimer);
        closeTimer = window.setTimeout(() => {
          if (!wrap.matches(':hover') && !wrap.matches(':focus-within')) {
            wrap.classList.remove('is-open');
          }
        }, 450);
      };

      wrap.addEventListener('mouseenter', open);
      wrap.addEventListener('mouseleave', scheduleClose);
      wrap.addEventListener('focusin', open);
      wrap.addEventListener('focusout', scheduleClose);

      wrap.dataset.fgHoverReady = 'true';
    });
  };

  document.addEventListener('DOMContentLoaded', () => initMiniCartHover());
  document.addEventListener('shopify:section:load', (event) => initMiniCartHover(event.target));
  initMiniCartHover();
})();


/* V72 announcement slideshow */
(() => {
  const initAnnouncements = (root = document) => root.querySelectorAll('[data-fg-announcement]').forEach((bar) => {
    if (bar.dataset.fgAnnouncementReady) return;
    bar.dataset.fgAnnouncementReady = 'true';
    if (bar.dataset.slideshow !== 'true') {
      bar.querySelectorAll('[data-fg-announcement-slide]').forEach((slide) => {
        slide.hidden = false;
      });
      return;
    }

    const slides = Array.from(bar.querySelectorAll('[data-fg-announcement-slide]'));
    if (slides.length <= 1) return;

    const prev = bar.querySelector('[data-fg-announcement-prev]');
    const next = bar.querySelector('[data-fg-announcement-next]');
    const autoplay = bar.dataset.autoplay === 'true';
    const speed = Math.max(2000, Number(bar.dataset.speed || 4000));
    let index = 0;
    let timer = null;

    const show = (nextIndex) => {
      index = (nextIndex + slides.length) % slides.length;

      slides.forEach((slide, i) => {
        const active = i === index;
        slide.hidden = !active;
        slide.classList.toggle('is-active', active);
      });
    };

    const stop = () => {
      if (timer) {
        window.clearInterval(timer);
        timer = null;
      }
    };

    const start = () => {
      stop();
      if (!autoplay || document.hidden || window.Shopify?.designMode) return;
      timer = window.setInterval(() => show(index + 1), speed);
    };

    prev?.addEventListener('click', () => {
      show(index - 1);
      start();
    });

    next?.addEventListener('click', () => {
      show(index + 1);
      start();
    });

    bar.addEventListener('mouseenter', stop);
    bar.addEventListener('mouseleave', start);
    bar.addEventListener('focusin', stop);
    bar.addEventListener('focusout', start);

    document.addEventListener('visibilitychange', () => {
      if (document.hidden) stop();
      else start();
    });

    bar._fgAnnouncementShow = show;
    bar._fgAnnouncementStop = stop;
    show(0);
    start();
  });
  initAnnouncements();
  document.addEventListener('shopify:section:load', e => initAnnouncements(e.target));
  document.addEventListener('shopify:block:select', e => {
    const slide = e.target.closest('[data-fg-announcement-slide]');
    const bar = slide?.closest('[data-fg-announcement]');
    if (bar?._fgAnnouncementShow) {bar._fgAnnouncementStop();bar._fgAnnouncementShow([...bar.querySelectorAll('[data-fg-announcement-slide]')].indexOf(slide));}
    const details = e.target.querySelector('details');
    if (details) details.open = true;
  });
})();


/* V75: product-page quantity plus/minus stepper */
(() => {
  document.addEventListener('click', (event) => {
    const minus = event.target.closest('[data-fg-product-qty-minus]');
    const plus = event.target.closest('[data-fg-product-qty-plus]');
    if (!minus && !plus) return;

    event.preventDefault();

    const stepper = (minus || plus).closest('[data-fg-product-qty-stepper]');
    const option = stepper?.closest('.fg-option--qty');
    const input = option?.querySelector('[data-fg-product-qty-input]');
    const value = stepper?.querySelector('[data-fg-product-qty-value]');

    if (!input || !value) return;

    const current = Math.max(1, Number(input.value || 1));
    const next = plus ? current + 1 : Math.max(1, current - 1);

    input.value = String(next);
    value.textContent = String(next);

    input.dispatchEvent(new Event('change', { bubbles: true }));
  });
})();


/* V77 — automatic endless scroll for paginated product/search grids */
(() => {
  const grids = Array.from(document.querySelectorAll('[data-fg-infinite-grid]'));
  if (!grids.length) return;

  grids.forEach((grid) => {
    let pagination = grid.querySelector('[data-fg-infinite-pagination]');
    if (!pagination) return;

    let next = pagination.querySelector('[data-fg-infinite-next]');
    if (!next) return;

    let loading = false;
    let finished = false;

    const loadingEl = document.createElement('div');
    loadingEl.className = 'fg-infinite-loading';
    loadingEl.textContent = 'Loading more products…';
    loadingEl.hidden = true;
    grid.appendChild(loadingEl);

    const loadNext = async () => {
      if (loading || finished || !next?.href) return;
      loading = true;
      loadingEl.hidden = false;

      try {
        const response = await fetch(next.href, {
          headers: { 'Accept': 'text/html' }
        });
        if (!response.ok) throw new Error('Unable to load next page');

        const html = await response.text();
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const nextGrid = doc.querySelector('[data-fg-infinite-grid]');

        if (!nextGrid) {
          finished = true;
          observer.disconnect();
          return;
        }

        const newPagination = nextGrid.querySelector('[data-fg-infinite-pagination]');
        const newNext = newPagination?.querySelector('[data-fg-infinite-next]');

        Array.from(nextGrid.children).forEach((child) => {
          if (child.matches('[data-fg-infinite-pagination], .fg-infinite-loading')) return;
          grid.insertBefore(document.importNode(child, true), pagination);
        });

        if (newNext?.href) {
          next.href = newNext.href;
        } else {
          finished = true;
          pagination.remove();
          pagination = null;
          next = null;
          observer.disconnect();
        }
      } catch (error) {
        // Keep normal pagination URL available in DOM if loading fails.
        loadingEl.textContent = 'More products could not be loaded.';
        window.setTimeout(() => {
          loadingEl.textContent = 'Loading more products…';
          loadingEl.hidden = true;
        }, 1800);
      } finally {
        loading = false;
        if (!finished) loadingEl.hidden = true;
      }
    };

    const observer = new IntersectionObserver((entries) => {
      if (entries.some((entry) => entry.isIntersecting)) loadNext();
    }, {
      rootMargin: '700px 0px'
    });

    observer.observe(pagination);
  });
})();


/* V83 — cart recommendations carousel */
(() => {
  const carousel = document.querySelector('[data-fg-cart-carousel]');
  if (!carousel) return;

  const track = carousel.querySelector('[data-fg-cart-carousel-track]');
  const prev = document.querySelector('[data-fg-cart-carousel-prev]');
  const next = document.querySelector('[data-fg-cart-carousel-next]');
  if (!track || !prev || !next) return;

  const cardStep = () => {
    const card = track.querySelector('.fg-cart-recommendation-card');
    if (!card) return track.clientWidth;
    const styles = getComputedStyle(track);
    const gap = parseFloat(styles.columnGap || styles.gap || '0') || 0;
    return card.getBoundingClientRect().width + gap;
  };

  const update = () => {
    const max = Math.max(0, track.scrollWidth - track.clientWidth - 2);
    prev.disabled = track.scrollLeft <= 2;
    next.disabled = track.scrollLeft >= max;
  };

  prev.addEventListener('click', () => {
    track.scrollBy({ left: -cardStep(), behavior: 'smooth' });
  });

  next.addEventListener('click', () => {
    track.scrollBy({ left: cardStep(), behavior: 'smooth' });
  });

  track.addEventListener('scroll', () => requestAnimationFrame(update), { passive:true });
  window.addEventListener('resize', update);
  update();
})();


/* V85: cart-page plus/minus quantity controls */
(() => {
  let updating = false;

  const formatMoney = (cents) => {
    const amount = Number(cents || 0) / 100;
    const currency = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'AUD';
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'en-AU', {
        style: 'currency', currency
      }).format(amount);
    } catch (_) {
      return `$${amount.toFixed(2)}`;
    }
  };

  const changeLine = async (line, quantity) => {
    const response = await fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ line, quantity: Math.max(0, Number(quantity || 0)) })
    });
    if (!response.ok) throw new Error('Unable to update cart');
    return response.json();
  };

  const updateHeaderCount = (cart) => {
    document.querySelectorAll('.fg-cart-count').forEach((count) => {
      count.textContent = `(${cart.item_count})`;
    });
  };

  document.addEventListener('click', async (event) => {
    const minus = event.target.closest('[data-fg-page-cart-minus]');
    const plus = event.target.closest('[data-fg-page-cart-plus]');
    if (!minus && !plus) return;

    event.preventDefault();
    if (updating) return;

    const button = minus || plus;
    const stepper = button.closest('[data-fg-page-cart-stepper]');
    const itemRow = button.closest('[data-fg-page-cart-item]');
    const valueEl = stepper?.querySelector('[data-fg-page-cart-value]');
    const line = Number(stepper?.dataset.line || button.dataset.line || 0);
    const current = Math.max(0, Number(valueEl?.textContent || 0));
    const next = Math.max(0, plus ? current + 1 : current - 1);
    if (!line) return;

    updating = true;
    document.querySelectorAll('[data-fg-page-cart-minus], [data-fg-page-cart-plus]').forEach((b) => b.disabled = true);

    try {
      const cart = await changeLine(line, next);
      updateHeaderCount(cart);

      if (next === 0) {
        itemRow?.remove();
      }

      // Shopify line numbers change after removal, so reindex every remaining row.
      document.querySelectorAll('[data-fg-page-cart-item]').forEach((row, index) => {
        const newLine = index + 1;
        row.dataset.line = String(newLine);
        const rowStepper = row.querySelector('[data-fg-page-cart-stepper]');
        if (rowStepper) rowStepper.dataset.line = String(newLine);
        row.querySelectorAll('[data-fg-page-cart-minus], [data-fg-page-cart-plus]').forEach((b) => {
          b.dataset.line = String(newLine);
        });

        const item = cart.items[index];
        const val = row.querySelector('[data-fg-page-cart-value]');
        const lineTotal = row.querySelector('[data-fg-page-cart-line-total]');
        if (item && val) val.textContent = String(item.quantity);
        if (item && lineTotal) lineTotal.textContent = formatMoney(item.final_line_price);
      });

      document.querySelectorAll('[data-fg-page-cart-subtotal]').forEach((el) => {
        el.textContent = formatMoney(cart.total_price);
      });

      if (cart.item_count === 0) {
        window.location.reload();
        return;
      }

      // Keep dropdown/full-screen cart views in sync if available.
      window.FGRefreshCartViews?.();
    } catch (_) {
      window.location.reload();
    } finally {
      updating = false;
      document.querySelectorAll('[data-fg-page-cart-minus], [data-fg-page-cart-plus]').forEach((b) => b.disabled = false);
    }
  });
})();


/* V91 — desktop navigation dropdowns open on hover */
(() => { const init=(root=document)=>{
const anchor=root.querySelector('.fg-nav');if(!anchor||anchor.dataset.fgNavReady)return;anchor.dataset.fgNavReady='true';

  const mq = window.matchMedia('(min-width: 901px) and (hover: hover) and (pointer: fine)');
  const dropdowns = Array.from(root.querySelectorAll('.fg-nav details.fg-nav__item'));
  if (!dropdowns.length) return;

  let closeTimer = null;

  const closeOthers = (current) => {
    dropdowns.forEach((details) => {
      if (details !== current) details.open = false;
    });
  };

  const bind = (details) => {
    details.addEventListener('mouseenter', () => {
      if (!mq.matches) return;
      window.clearTimeout(closeTimer);
      closeOthers(details);
      details.open = true;
    });

    details.addEventListener('mouseleave', () => {
      if (!mq.matches) return;
      window.clearTimeout(closeTimer);
      closeTimer = window.setTimeout(() => {
        details.open = false;
      }, 120);
    });

    details.addEventListener('focusin', () => {
      if (!mq.matches) return;
      window.clearTimeout(closeTimer);
      closeOthers(details);
      details.open = true;
    });

    details.addEventListener('focusout', (event) => {
      if (!mq.matches) return;
      if (details.contains(event.relatedTarget)) return;
      details.open = false;
    });
  };

  dropdowns.forEach(bind);

  mq.addEventListener?.('change', (event) => {
    if (!event.matches) dropdowns.forEach((details) => details.open = false);
  });

};init();document.addEventListener('shopify:section:load',event=>init(event.target));})();

// Stop removed section animations in the theme editor.
document.addEventListener('shopify:section:unload',event=>{
 event.target.querySelectorAll('[data-fg-hero-slider]').forEach(el=>el._fgHeroStop?.());
 event.target.querySelectorAll('[data-fg-announcement]').forEach(el=>el._fgAnnouncementStop?.());
});

/* V125 — product media thumbnail carousel */
(() => {
  const initGallery = (gallery) => {
    if (!gallery || gallery.dataset.fgGalleryReady === 'true') return;
    gallery.dataset.fgGalleryReady = 'true';

    const mediaItems = Array.from(gallery.querySelectorAll('[data-fg-product-media]'));
    const thumbs = Array.from(gallery.querySelectorAll('[data-fg-product-thumb]'));
    const track = gallery.querySelector('[data-fg-product-thumbs-track]');
    const prev = gallery.querySelector('[data-fg-product-thumbs-prev]');
    const next = gallery.querySelector('[data-fg-product-thumbs-next]');

    if (!mediaItems.length) return;

    const selectMedia = (mediaId, selectedThumb, shouldScroll = true) => {
      mediaItems.forEach((item) => {
        const active = String(item.dataset.mediaId) === String(mediaId);
        item.hidden = !active;
        item.classList.toggle('is-active', active);

        if (!active) {
          item.querySelectorAll('video').forEach((video) => video.pause?.());
        }
      });

      thumbs.forEach((thumb) => {
        const active = String(thumb.dataset.mediaId) === String(mediaId);
        thumb.classList.toggle('is-active', active);
        thumb.setAttribute('aria-pressed', active ? 'true' : 'false');
      });

      if (selectedThumb && shouldScroll) {
        selectedThumb.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
      }
    };

    const selectedIndex = () => {
      const i = thumbs.findIndex((thumb) => thumb.classList.contains('is-active'));
      return i >= 0 ? i : 0;
    };

    thumbs.forEach((thumb) => {
      thumb.addEventListener('click', () => selectMedia(thumb.dataset.mediaId, thumb));
    });

    const updateTrackLayout = () => {
      if (!track) return;
      const isScrollable = track.scrollWidth > track.clientWidth + 2;
      track.classList.toggle('is-scrollable', isScrollable);
    };

    prev?.addEventListener('click', () => {
      if (thumbs.length < 2) return;
      const index = (selectedIndex() - 1 + thumbs.length) % thumbs.length;
      selectMedia(thumbs[index].dataset.mediaId, thumbs[index]);
    });

    next?.addEventListener('click', () => {
      if (thumbs.length < 2) return;
      const index = (selectedIndex() + 1) % thumbs.length;
      selectMedia(thumbs[index].dataset.mediaId, thumbs[index]);
    });

    if (prev) prev.disabled = thumbs.length < 2;
    if (next) next.disabled = thumbs.length < 2;

    requestAnimationFrame(updateTrackLayout);
    window.addEventListener('resize', updateTrackLayout);
    if ('ResizeObserver' in window && track) {
      const observer = new ResizeObserver(updateTrackLayout);
      observer.observe(track);
    }
  };

  const initAll = (root = document) => {
    root.querySelectorAll('[data-fg-product-gallery]').forEach(initGallery);
  };

  initAll();
  document.addEventListener('shopify:section:load', (event) => initAll(event.target));
})();

(() => {
  const instances = new WeakMap();
  const init = (root = document) => root.querySelectorAll('[data-fg-bestsellers-carousel]').forEach((carousel) => {
    if (instances.has(carousel)) return;
    const track = carousel.querySelector('[data-fg-bestsellers-track]');
    if (!track) return;
    const abort = new AbortController();
    const signal = abort.signal;
    let drag = null, suppressClick = false;
    const dots = carousel.querySelector('[data-fg-bestsellers-dots]');
    let positions = [];
    const updateDots = () => {
      if (!dots || !positions.length) return;
      let active = 0;
      positions.forEach((position, i) => {
        if (Math.abs(position - track.scrollLeft) < Math.abs(positions[active] - track.scrollLeft)) active = i;
      });
      [...dots.children].forEach((button, i) => button.setAttribute('aria-current', String(i === active)));
    };
    const rebuildDots = () => {
      if (!dots) return;
      const max = Math.max(0, track.scrollWidth - track.clientWidth);
      positions = [0];
      const first = track.firstElementChild?.getBoundingClientRect().left || 0;
      [...track.children].forEach(card => {
        const position = Math.min(max, Math.max(0, card.getBoundingClientRect().left - first));
        if (position - positions[positions.length - 1] > 2) positions.push(position);
      });
      dots.hidden = max <= 2;
      dots.replaceChildren(...positions.map((position, i) => {
        const button = document.createElement('button');
        button.type = 'button';
        button.className = 'fg-bestsellers-dot';
        button.setAttribute('aria-label', `${dots.dataset.dotLabel} ${i + 1}`);
        button.setAttribute('aria-controls', track.id);
        button.addEventListener('click', () => track.scrollTo({left: position, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'}));
        return button;
      }));
      updateDots();
    };
    track.addEventListener('scroll', updateDots, {passive: true, signal});
    const resize = new ResizeObserver(rebuildDots);
    resize.observe(track);
    rebuildDots();
    track.addEventListener('dragstart', event => event.preventDefault(), {signal});
    track.addEventListener('pointerdown', event => {
      suppressClick = false;
      if (event.pointerType !== 'mouse' || event.button !== 0 || event.target.closest('button, input, select')) return;
      drag = {id: event.pointerId, x: event.clientX, start: track.scrollLeft, moved: false};
    }, {signal});
    track.addEventListener('pointermove', event => {
      if (!drag || drag.id !== event.pointerId) return;
      const distance = event.clientX - drag.x;
      if (!drag.moved && Math.abs(distance) < 5) return;
      if (!drag.moved) {
        drag.moved = true;
        track.setPointerCapture(event.pointerId);
        track.classList.add('is-dragging');
      }
      event.preventDefault();
      track.scrollLeft = drag.start - distance;
    }, {signal});
    const endDrag = () => {
      if (drag?.moved) suppressClick = true;
      drag = null;
      track.classList.remove('is-dragging');
    };
    window.addEventListener('pointerup', endDrag, {signal});
    window.addEventListener('pointercancel', endDrag, {signal});
    track.addEventListener('click', event => {
      if (suppressClick) {
        event.preventDefault();
        event.stopPropagation();
        suppressClick = false;
      }
    }, {capture: true, signal});
    track.addEventListener('keydown', event => {
      if (event.target !== track || !['ArrowLeft', 'ArrowRight'].includes(event.key)) return;
      event.preventDefault();
      const gap = parseFloat(getComputedStyle(track).columnGap) || 0;
      const step = (track.firstElementChild?.getBoundingClientRect().width || track.clientWidth) + gap;
      track.scrollBy({left: event.key === 'ArrowLeft' ? -step : step, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'});
    }, {signal});
    instances.set(carousel, () => { abort.abort(); resize.disconnect(); instances.delete(carousel); });
  });
  document.addEventListener('shopify:section:load', event => init(event.target));
  document.addEventListener('shopify:section:unload', event => event.target.querySelectorAll('[data-fg-bestsellers-carousel]').forEach(carousel => instances.get(carousel)?.()));
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init());
  else init();
})();
